<template>
  <div class="content">
    <div class="text-center loading-prepare" v-if="isLoading">
      <img
        src="@/assets/images/loading-d-dots.gif"
        alt="loading"
        class="loading-icon"
      />
    </div>
    <div v-else-if="products.length > 0 && !isLoading">
      <div class="h-100">
        <div
          class="d-flex justify-content-between align-items-center p-3 w-100"
        >
          <b-input-group>
            <b-form-input
              @keypress="handleInputSearch"
              placeholder="Search Product Name"
              v-model="textSearchInput"
              class="position-relative w-100"
            >
            </b-form-input>
            <span class="icon-search">
              <font-awesome-icon :icon="['fas', 'search']"
            /></span>
          </b-input-group>
          <!-- <div>
            <b-dropdown
              id="dropdown-filter"
              variant="light"
              right
              class="py-1 w-100"
            >
              <template #button-content>
                <div class="d-flex align-items-center w-100">
                  <div>
                    {{ selectName ? selectName : "Please Select" }}
                  </div>
                </div>
              </template>
              <b-dropdown-item
                v-for="(item, bindex) in filterList"
                :key="`filter-${bindex}`"
                @click="onSelectFilter(item)"
                :class="{ active: `${selectFilter}` === `${item.id}` }"
              >
                <div>
                  {{ item.name }}
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div> -->
        </div>
        <div
          class="product-list"
          :class="{ paddingBottom: selectedProdcuts.length > 0 }"
        >
          <div
            v-for="(i, index) in products"
            :key="index"
            class="mb-3 product-wrp px-3"
          >
            <div class="d-flex align-items-center">
              <!-- <b-form-checkbox
                :id="`product_${i.id}`"
                :name="`checkbox_${i.id}`"
                :value="{
                  id: i.id,
                  name: i.name
                }"
                :unchecked-value="0"
                v-model="selectedProdcuts"
              >
              </b-form-checkbox> -->
              <ProductCard :item="i" />
            </div>
            <hr />
            <div class="d-flex justify-content-between align-items-center py-3">
              <div class="detail-footer d-flex align-items-center">
                <div>{{ i.available_stock }} available</div>
                <div>|</div>
                <div>{{ i.sales }} sold</div>
              </div>
              <div class="botton-footer">
                <button class="btn btn-primary" @click="gotoExternal(i)">
                  Details
                </button>
                <button class="btn btn-primary" @click="sendProduct(i)">
                  Send
                </button>
              </div>
            </div>
          </div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalProducts"
            :per-page="pageSize"
            class="pagination-main pb-4"
            @change="handlePagination"
            align="center"
          ></b-pagination>
        </div>
      </div>

      <!-- <div class="fixed-footer px-3" v-if="selectedProdcuts.length > 0">
        <div class="footer-detail">
          <span>{{ selectedProdcuts.length }}</span
          ><span>/{{ list.length }} products selected</span>
        </div>
        <div class="footer-button">
          <button @click="onCancel">Cancel</button>
          <button>Send</button>
        </div>
      </div> -->
    </div>
    <div v-else class="d-flex justify-content-center h-100 bg-white pt-3">
      {{ $t("noDataProduct") }}
    </div>
  </div>
</template>

<script>
import ProductCard from "./ProductCard.vue";
import { EventBus } from "@/helpers/event";
import { MESSAGE_TYPES } from "@/helpers/constants.js";

export default {
  components: {
    ProductCard
  },
  data() {
    return {
      products: [],
      totalProducts: 0,
      selectedProdcuts: [],
      textSearchInput: "",
      selectFilter: 0,
      currentPage: 1,
      pageSize: 10,
      selectName: "",
      isLoading: false,
      searchTimeOut: null,
      filterList: [
        {
          id: 1,
          name: "test 1 test 1 test 1 test 1 test 1 test 1 test 1 test 1 test 1"
        },
        {
          id: 2,
          name: "test 2"
        },
        {
          id: 3,
          name: "test 3"
        },
        {
          id: 4,
          name: "test 4"
        },
        {
          id: 5,
          name: "test 5"
        }
      ]
    };
  },

  mounted() {
    this.fetchProductList();
  },
  methods: {
    handlePagination(pageNo) {
      this.currentPage = pageNo;
      this.fetchProductList();
    },
    sendProduct(item) {
      console.log("🚀 ~ sendProduct ~ item:", item);
      let dataSend = {
        text: item.item_name,
        imageUrl: item.image_url,
        attachments: null,
        isReply: false,
        replyMessageId: "",
        externalLink: item.externalLink,
        custom: {
          id: item.item_id,
          price: item.price_range
        }
      };
      EventBus.$emit("send-message-custom", {
        data: dataSend,
        type: MESSAGE_TYPES.Flex
      });
    },
    gotoExternal(item) {
      window.open(item.externalLink, "_blank");
    },
    handleSearch() {
      if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
      this.searchTimeOut = setTimeout(() => {
        this.fetchProductList(this.textSearchInput);
      }, 300);
    },
    async fetchProductList(search = "") {
      try {
        this.isLoading = true;
        let query = `?customerId=${this.$store.state.chatUserGUIDSelected}&currentPage=${this.currentPage}&pageSize=${this.pageSize}`;
        if (search) query += `&search=${encodeURIComponent(search)}`;
        let result = await fetch(
          `${this.$shopeeUrl}/shopee/getProducts${query}`,
          {
            method: "GET",
            headers: new Headers(this.$headersChat)
          }
        );

        let resultJson = await result.json();
        this.products = resultJson.detail.items ?? [];
        this.totalProducts = resultJson.detail.total_count;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    handleInputSearch(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        this.handleSearch();
      }
    },
    onSelectFilter(item) {
      this.selectFilter = item.id;
      this.selectName = item.name;
    },
    onCancel() {
      this.selectedProdcuts = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background-color: #f6f6f6;
  height: 100%;
  hr {
    margin: 0 !important;
    border-top: 0.1px solid #e4e4e4 !important;
  }

  .icon-search {
    position: absolute;
    top: 7px;
    right: 15px;
    color: #768192;
  }

  #dropdown-filter {
    ::v-deep .dropdown-toggle {
      display: flex;
      align-items: center;
      background-color: transparent !important;
      border: none !important;
      width: 80px;

      div {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }

    ::v-deep .dropdown-menu.show {
      width: 80px !important;

      .active {
        background-color: #e2dff3 !important;
        text-decoration: none;
      }

      .dropdown-item {
        div {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
  }

  .product-list {
    overflow: auto;
    width: 100%;
    height: 100%;
    height: calc(100dvh - 370px);

    &.paddingBottom {
      padding-bottom: 100px;
    }

    &::-webkit-scrollbar {
      width: 0.35rem;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(177, 175, 175, 0.3);
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
    }

    .product-wrp {
      background-color: #fff;

      .detail-footer {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;

        div:first-child {
          color: #9c9c9c;
        }

        div:last-child {
          font-weight: bold;
        }
      }

      .botton-footer {
        display: flex;
        gap: 10px;

        button {
          padding: 3px 10px;

          &:focus-visible,
          &:focus {
            outline: none !important;
          }

          &:first-child {
            color: #832abf;
            border: 1px solid #832abf;
            background-color: #fff;
          }

          &:last-child {
            color: #fff;
            border: 1px solid #832abf;
            background-color: #832abf;
          }
        }
      }

      ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
        border-color: #832abf !important;
        background-color: #832abf !important;
      }
    }
  }

  .fixed-footer {
    position: absolute;
    bottom: 0;
    background-color: #fff !important;
    height: 70px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 10px 5px 7px 3px rgba(0, 0, 0, 0.3);

    .footer-detail {
      span:first-child {
        color: #832abf;
      }
    }

    .footer-button {
      display: flex;
      gap: 10px;
      button {
        padding: 5px 15px;
        border-radius: 5px;

        &:focus-visible,
        &:focus {
          outline: none !important;
        }

        &:first-child {
          color: #832abf;
          border: none !important;
          background-color: #fff;
        }

        &:last-child {
          color: #fff;
          border: 1px solid #832abf;
          background-color: #832abf;
        }
      }
    }
  }
}

@media (max-width: 767.98px) {
  .product-list {
    height: calc(100dvh - 340px) !important;
  }
  .fixed-footer {
    position: fixed !important;
    bottom: 0;
  }
}
</style>
